var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schedule-page"},[_c('div',{staticClass:"btn-back",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../assets/bar-map/btn-back.png"),"alt":""}})]),_c('img',{staticClass:"schedule-img",attrs:{"src":require("../assets/schedule.png"),"alt":"活动日程"},on:{"click":_vm.openPreview}})])
}
var staticRenderFns = []

export { render, staticRenderFns }